export const GET_STUDENTS = "GET_STUDENTS";
export const GET_STUDENT_BY_ID = "GET_STUDENT_BY_ID";
export const UPDATE_STUDENT = "UPDATE_STUDENT";
export const DELETE_STUDENT = "DELETE_STUDENT";
export const CREATE_STUDENT = "CREATE_STUDENT";
export const GET_CURRENT_STUDENT = "GET_CURRENT_STUDENT";
export const GET_MY_STUDENT = "GET_MY_STUDENT";
